<rosie-alert *ngIf="hasSelectionError && selectionErrorMeesage" [type]="'error'" [innerHtml]="selectionErrorMeesage"
  (click)="handleAlternativeAction()"></rosie-alert>
<div class="typeahead-wrapper google-places-search-wrapper">
  <ng-icon [name]="icon" class="search-icon" [color]="highlight ? '#822ac6' : '#9487A0'" [size]="'22px'"
    [strokeWidth]="'1.5'"></ng-icon>
  <input [name]="''" [editable]="allowFreeText" [autocomplete]="'off'" [formControl]="searchControl" [ngbTypeahead]="searchFn"
    (blur)="showErrorOnBlurIfInvalid()" [focusFirst]="false" [selectOnExact]="true"
    [class]="'form-control rosie-typeahead-input'" [autocomplete]="'new-password'"
    (selectItem)="handleOptionSelected($event)" [resultFormatter]="resultFormatter" [inputFormatter]="inputFormatter"
    [resultTemplate]="rt"
    [ngClass]="{'active': instance?.isPopupOpen(), 'has-value': hasValue, 'invalid': showOptionError, 'highlight': highlight}"
    #instance="ngbTypeahead" [placeholder]="placeholder | translate">
  <rosie-validation-error [show]="showOptionError && searchControl?.touched"
    [translationKey]="'Select an option from the search dropdown or leave field blank and use website field instead.'"></rosie-validation-error>
  <div class="search">{{helperText}}</div>
  <ng-icon *ngIf="showClearSelection" (click)="clearSelection()" [name]="'heroXCircle'" class="clear-selection"
    [color]="'#7F728A'" [size]="'22px'" [strokeWidth]="'1.5'"></ng-icon>
</div>
<ng-template #rt let-r="result" let-t="term">
  <div class="d-flex align-items-center google-dropdown-item">
    <span class="google-dropdown-item-icon"></span>
    <span class="business-name">
      <ngb-highlight [result]="r?.structuredFormatting?.mainText" [term]="t"></ngb-highlight>
    </span>&nbsp;
    <small class="business-address">
      <ngb-highlight [result]="r?.structuredFormatting?.secondaryText" [term]="t"></ngb-highlight>
    </small>
  </div>
</ng-template>